import { c as _c } from "react/compiler-runtime";
import DeleteForever from "@mui/icons-material/DeleteForever";
import { Button, Dialog, Stack } from "@mui/material";
import type { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import type { useFormik } from "formik";
import React from "react";
import { useI18nContext } from "#/shared/hooks";
export type EditModalProps = DialogProps & {
  title: string;
  summary: string;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
  formik: ReturnType<typeof useFormik<any>>;
  children: React.ReactNode;
};
export const EditFormModal: React.FC<EditModalProps> = t0 => {
  const $ = _c(53);
  let children;
  let formik;
  let isDeleting;
  let onClose;
  let onDelete;
  let props;
  let summary;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      summary,
      isDeleting,
      onClose,
      onDelete,
      formik,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = formik;
    $[3] = isDeleting;
    $[4] = onClose;
    $[5] = onDelete;
    $[6] = props;
    $[7] = summary;
    $[8] = title;
  } else {
    children = $[1];
    formik = $[2];
    isDeleting = $[3];
    onClose = $[4];
    onDelete = $[5];
    props = $[6];
    summary = $[7];
    title = $[8];
  }
  const {
    LL
  } = useI18nContext();
  const t1 = formik.handleSubmit;
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      textTransform: "capitalize"
    };
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== title) {
    t3 = <DialogTitle sx={t2}>{title}</DialogTitle>;
    $[10] = title;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== summary) {
    t4 = <DialogContentText>{summary}</DialogContentText>;
    $[12] = summary;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== children) {
    t5 = <Stack spacing={2} mt={2}>{children}</Stack>;
    $[14] = children;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <DialogContent>{t4}{t5}</DialogContent>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== LL) {
    t7 = LL.DELETE_THIS_PROJECT();
    $[19] = LL;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DeleteForever />;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      mr: "auto"
    };
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== LL) {
    t10 = LL.DELETE();
    $[23] = LL;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== isDeleting || $[26] !== onDelete || $[27] !== t10 || $[28] !== t7) {
    t11 = <Button title={t7} color="error" endIcon={t8} loading={isDeleting} loadingPosition="end" onClick={onDelete} sx={t9}>{t10}</Button>;
    $[25] = isDeleting;
    $[26] = onDelete;
    $[27] = t10;
    $[28] = t7;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== LL) {
    t12 = LL.CANCEL();
    $[30] = LL;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== onClose || $[33] !== t12) {
    t13 = <Button onClick={onClose}>{t12}</Button>;
    $[32] = onClose;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  const t14 = formik.isSubmitting;
  let t15;
  if ($[35] !== LL) {
    t15 = LL.UPDATE();
    $[35] = LL;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== formik.isSubmitting || $[38] !== t15) {
    t16 = <Button type="submit" loading={t14}>{t15}</Button>;
    $[37] = formik.isSubmitting;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t11 || $[41] !== t13 || $[42] !== t16) {
    t17 = <DialogActions>{t11}{t13}{t16}</DialogActions>;
    $[40] = t11;
    $[41] = t13;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== formik.handleSubmit || $[45] !== t17 || $[46] !== t3 || $[47] !== t6) {
    t18 = <form onSubmit={t1}>{t3}{t6}{t17}</form>;
    $[44] = formik.handleSubmit;
    $[45] = t17;
    $[46] = t3;
    $[47] = t6;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== onClose || $[50] !== props || $[51] !== t18) {
    t19 = <Dialog {...props} onClose={onClose}>{t18}</Dialog>;
    $[49] = onClose;
    $[50] = props;
    $[51] = t18;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  return t19;
};